const stateApp = {
    ticketData: null,
    ticketFetchLoading: false,
};

// getters
const getters = {
    ticketData: (state) => state.ticketData,
    ticketFetchLoading: (state) => state.ticketFetchLoading,
};

// actions
const actions = {
    getTicketData(context, data)
    {
        context.commit('setTicketData', null);
        context.commit('setTicketFetchStatus', true);
        context.dispatch('getBetslipData', data);
        context.commit('setTicketFetchStatus', false);
    },
    setTicketData(context, data)
    {
        context.commit('setTicketData', data);
    },
};

// mutations
const mutations = {
    setTicketData(state, data)
    {
        state.ticketData = data;
    },
    setTicketFetchStatus(state, data)
    {
        state.ticketFetchLoading = data;
    },
};

export default
{
    state: stateApp,
    getters,
    actions,
    mutations,
};
